import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-r', 'LetterR', [["path",{"d":"M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"}],["path",{"d":"M12 13l5 7"}]]);